import React from 'react'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import { visuallyHidden } from '@mui/utils'
import { TiArrowUnsorted, TiArrowSortedUp } from 'react-icons/ti'

interface Props {
  order: 'asc' | 'desc'
  orderBy: string
  onRequestSort: (event: any, property: string) => void
  headers: string[]
  rowCount?: number
}

function TableHeader (props: Props) {
  const { order, orderBy, onRequestSort, headers } = props
  const createSortHandler = (property: string) => (event: any) => {
    onRequestSort(event, property)
  }

  return (
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            header === 'reportId'
              ? (null)
              : <TableCell className={header.toLowerCase() === 'action' ? 'action-column' : ''} key={header.toLowerCase() === 'reportid' ? '' : header.toLowerCase() }
              sortDirection={orderBy === header ? order : false}
            >
              <TableSortLabel
                active={orderBy === header}
                direction={orderBy === header ? order : 'asc'}
                onClick={createSortHandler(header)}
                IconComponent={orderBy !== header ? TiArrowUnsorted : TiArrowSortedUp }
                hideSortIcon={header.toLowerCase() === 'action'}
              >
                {header.replace(/([a-z])([A-Z])/g, '$1 $2')}
                {orderBy === header
                  ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                    )
                  : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
  )
}

export default TableHeader
